var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        id: "storyList-modal",
        title: _vm.$t("chatbotv2.integrateStoryWithSupsisWidget"),
        wrapClassName: "vertical-center-modal",
        visible: _vm.modalVisible,
        footer: null,
      },
      on: {
        visibleChange: function (isVisible) {
          return _vm.$emit("modal-visible2", isVisible)
        },
        cancel: function ($event) {
          return _vm.handleCancel()
        },
      },
    },
    [
      _c(
        "a-form",
        {
          staticClass: "d-flex flex-column justify-content-center",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.handleSave.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "a-form-item",
            {
              attrs: {
                label: _vm.$t("chatbotv2.selectIntegratingStory"),
                fieldDecoratorOptions: {
                  rules: [
                    {
                      required: true,
                      message: _vm.$t(
                        "chatbotv2.integrateStoryWithSupsisWidget"
                      ),
                    },
                  ],
                },
              },
            },
            [
              _c(
                "a-select",
                {
                  on: { change: _vm.handleChange },
                  model: {
                    value: _vm.selectedStory,
                    callback: function ($$v) {
                      _vm.selectedStory = $$v
                    },
                    expression: "selectedStory",
                  },
                },
                _vm._l(_vm.stories, function (story) {
                  return _c(
                    "a-select-option",
                    { key: story.id, attrs: { value: story.id } },
                    [_vm._v(_vm._s(story.title) + "\n                ")]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-row justify-content-between" }, [
        _c(
          "div",
          { staticClass: "d-flex flex-row justify-content-start" },
          [
            !!_vm.selectedStory
              ? _c(
                  "a-button",
                  {
                    attrs: { type: "danger" },
                    on: {
                      click: function ($event) {
                        return _vm.revokeDefault()
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      [
                        _c("a-icon", {
                          staticClass: "px-1",
                          attrs: { type: "api" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      _vm._s(_vm.$t("chatbotv2.uninstall")) + "\n            "
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex flex-row justify-content-end" },
          [
            _c(
              "a-button",
              {
                staticClass: "mr-1 ant-btn-primary",
                attrs: { disabled: !_vm.isChangedStory },
                on: {
                  click: function ($event) {
                    return _vm.handleOk()
                  },
                },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("chatbotv2.install")) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticClass: "ml-1",
                on: {
                  click: function ($event) {
                    return _vm.handleCancel()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.cancel")))]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }